//Esto es pura configuracion del framework

/**
  This file is used for controlling the global states of the components,
  you can customize the states for the different components here.
*/

import { createContext, useContext, useReducer, useMemo } from "react";

// The Soft UI Dashboard PRO Material main context
const Context = createContext(null);

// Setting custom name for the context which is visible on react dev tools
Context.displayName = "Context";

// Soft UI Dashboard React reducer
function reducer(state, action) {
  switch (action.type) {
    case "TRANSPARENT_NAVBAR": {
      return { ...state, transparentNavbar: action.value };
    }
    case "FIXED_NAVBAR": {
      return { ...state, fixedNavbar: action.value };
    }
    case "DIRECTION": {
      return { ...state, direction: action.value };
    }
    case "LAYOUT": {
      return { ...state, layout: action.value };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// Soft UI Dashboard React context provider
function ControllerProvider({ children }) {
  const initialState = {
    transparentNavbar: true,
    fixedNavbar: true,
    direction: "ltr",
    layout: "home",
  };

  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
}

// Soft UI Dashboard React custom hook for using context
function useController() {
  const context = useContext(Context);

  if (!context) {
    throw new Error("useController should be used inside the ControllerProvider.");
  }

  return context;
}   

// Context module functions
const setTransparentNavbar = (dispatch, value) => dispatch({ type: "TRANSPARENT_NAVBAR", value });
const setFixedNavbar = (dispatch, value) => dispatch({ type: "FIXED_NAVBAR", value });
const setDirection = (dispatch, value) => dispatch({ type: "DIRECTION", value });
const setLayout = (dispatch, value) => dispatch({ type: "LAYOUT", value });

export {
  ControllerProvider,
  useController,
  setTransparentNavbar,
  setFixedNavbar,
  setDirection,
  setLayout,
};
